import { enableMocking } from '@/src/mocks/enable'

void enableMocking().then(() => {
  // Metro web can fail resolving this entry when loaded via dynamic import.
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  require('expo-router/entry')
})
